import { NOTIFICATION_CATEGORY_ICONS, NOTIFICATION_PRIORITY_VARIANTS, NOTIFICATION_TOAST_AUTO_CLOSE, getResolveActionLabel } from "../constants.js";
import { NotificationsViewModel, toNotificationItem } from "../viewmodels/NotificationsViewModel.js";
import { openNotification } from "../open-notification.js";
import "react";
import { Icon, Toast, toastManager } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { useEvent, useSingleton } from "mvc-kit/react";
//#region src/modules/Notifications/components/NotificationToasts.tsx
/**
* Renders nothing — turns NotificationCreated VM events into priority-tiered
* toasts (top-right, like utils/Notifications background events) and dismisses
* them on NotificationResolved so a stale "Take it" never lingers after a
* teammate wins. Never touches the unread badge.
*/
function NotificationToasts() {
	const vm = useSingleton(NotificationsViewModel);
	useEvent(vm, "created", (notification) => {
		const variant = NOTIFICATION_PRIORITY_VARIANTS[notification.priority];
		const item = toNotificationItem(notification);
		toastManager(/* @__PURE__ */ jsx(Toast, {
			actionLabel: notification.requiresAction ? getResolveActionLabel(notification.category) : "View",
			icon: /* @__PURE__ */ jsx(Icon, {
				Icon: NOTIFICATION_CATEGORY_ICONS[notification.category],
				color: variant === "neutral" ? void 0 : variant
			}),
			onAction: () => {
				if (notification.requiresAction) {
					vm.resolve(notification.id);
					toastManager.dismiss(notification.id);
				} else openNotification(item);
			},
			title: notification.title,
			children: notification.body
		}), {
			autoClose: NOTIFICATION_TOAST_AUTO_CLOSE[notification.priority],
			hideProgressBar: true,
			onClick: (evt) => {
				if ((evt?.target)?.closest?.("button")) return;
				openNotification(item);
			},
			position: toastManager.POSITION.TOP_RIGHT,
			toastId: notification.id,
			variant: variant === "neutral" ? "info" : variant
		});
	});
	useEvent(vm, "resolved", ({ notificationId }) => {
		toastManager.dismiss(notificationId);
	});
	return null;
}
//#endregion
export { NotificationToasts };

//# sourceMappingURL=NotificationToasts.js.map